import * as React from "react";
const SvgFilter = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 4h18l-7 8.5V20l-4 2v-9.5L3 4z", strokeWidth: 2, fill: "none", strokeLinejoin: "round" }));
export { SvgFilter as ReactComponent };
